import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['progressBar', 'details']
  static values = {
    totalItems: Number,
    completedItems: Number,
    toggleUrlTemplate: String,
  }

  // Measure and set max-height for symmetric expand/collapse animation
  detailsTargetConnected(details) {
    details.style.maxHeight = `${details.scrollHeight}px`
  }

  toggleCompletion(event) {
    const itemId = event.currentTarget.dataset['itemId']
    const isChecked = event.currentTarget.checked

    // Update UserItem completion status
    this.#toggleCompletion(itemId)

    // Find the corresponding checkmark by ID and set the correct color
    const checkmark = document.getElementById(`checkmark-${itemId}`)
    if (checkmark) {
      checkmark.classList.toggle('text-success')
      checkmark.classList.toggle('text-muted')
    }

    // Update completion text and color
    const completionText = document.getElementById(`completion-text-${itemId}`)
    if (completionText) {
      completionText.textContent = isChecked
        ? 'Completed'
        : "I've Completed This"
      if (isChecked) {
        completionText.classList.add('text-success')
      } else {
        completionText.classList.remove('text-success')
      }
    }

    // Toggle between status text and completed date display
    const statusText = document.getElementById(`status-text-${itemId}`)
    const completedDate = document.getElementById(`completed-date-${itemId}`)
    if (completedDate) {
      if (isChecked) {
        const today = new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })
        completedDate.textContent = `Completed: ${today}`
        completedDate.classList.remove('hidden')
        statusText.classList.add('hidden')
      } else {
        completedDate.classList.add('hidden')
        statusText.classList.remove('hidden')
      }
    }

    // Swap between default description/CTA and description_upon_completion
    const defaultContent = document.getElementById(`default-content-${itemId}`)
    const completedContent = document.getElementById(
      `completed-content-${itemId}`,
    )
    if (defaultContent && completedContent) {
      defaultContent.classList.toggle('hidden', isChecked)
      completedContent.classList.toggle('hidden', !isChecked)

      const details = event.currentTarget.closest('.details')
      if (details) {
        details.style.maxHeight = `${details.scrollHeight}px`
      }
    }

    // Update progress bar
    this.#updateProgressBar(isChecked)
  }

  #updateProgressBar(isChecked) {
    // Update completed items count
    this.completedItemsValue = isChecked
      ? this.completedItemsValue + 1
      : this.completedItemsValue - 1

    // Calculate new progress percentage
    const progressPercent =
      this.totalItemsValue > 0
        ? (this.completedItemsValue / this.totalItemsValue) * 100
        : 0

    // Update progress bar using Stimulus target
    this.progressBarTarget.style.width = `${progressPercent}%`
    this.progressBarTarget.setAttribute('aria-valuenow', progressPercent)
  }

  async #toggleCompletion(itemId) {
    const url = this.toggleUrlTemplateValue.replace(':id', itemId)
    await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
  }
}
